import React from 'react'
import { ClearButton, Typeahead } from 'react-bootstrap-typeahead'
import 'react-bootstrap-typeahead/css/Typeahead.css'

const FormTypeahead = ({
  placeholder,
  onChangeVal,
  options,
  dispField,
  valField,
  control,
  onClearSelect,
  ...rest
}) => {
  return (
    <Typeahead
      id='single'
      clearButton
      selectHintOnEnter
      options={options}
      labelKey={dispField}
      placeholder={placeholder}
      selected={control}
      flip={true}
      onChange={e => onChangeVal(e[0])}
      {...rest}
    >
      {({ onClear, selected, toggleMenu, disabled, ...test }) =>
        !!selected.length && (
          <div className="rbt-aux">
            <ClearButton
              onClick={e => {
                if (rest.disabled) return;

                onClear();
                if (onClearSelect) {
                  onClearSelect();
                  toggleMenu()
                }
              }}
              onFocus={e => {
                // Prevent the main input from auto-focusing again.
                e.stopPropagation();
              }}
              onMouseDown={e => {
                // Prevent input from blurring when button is clicked.
                e.preventDefault();
              }}
            />
          </div>
        )
      }
    </Typeahead>
  )
}

export default FormTypeahead
